import React from "react";
import AlinaLogo from "../../../assets/images/AlinaLogo.png";
import { Grid } from "@mui/material";
import { Stack } from "@mui/material";
import { normalizeDateTime } from "../../helpers/normalizeDateTime";

const TreatmentQuote = (
  caseDetails,
  totalAmountPaid,
  downPayment,
  termsOfPaymentAfterDesign,
  isDownpaymentPaid
) => {
  console.log(caseDetails);
  return (
    <>
      <div
        style={{
          width: "400px",
          fontSize: "10px",
          fontFamily: "Helvetica",
          color: "black",
        }}
      >
        <Grid container>
          <Grid item xs={6}>
            <div>
              <img src={AlinaLogo} alt="react logo" width={"100px"} />
            </div>
          </Grid>
          <Grid item xs={6}>
            <Stack
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <div style={{ fontSize: "25px", fontFamily: "Helvetica" }}>
                Treatment Quote
              </div>
              <div
                style={{
                  fontSize: "15px",
                  fontFamily: "Helvetica",
                  color: "gray",
                }}
              >
                {caseDetails.caseNo}
              </div>
            </Stack>
          </Grid>
        </Grid>
        <div
          style={{
            fontSize: "10px",
            fontFamily: "Helvetica",
            fontWeight: 700,
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          Alina Invisible Braces
        </div>
        <Grid container>
          <Grid item xs={6}>
            <Stack
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  fontSize: "10px",
                  fontFamily: "Helvetica",
                  color: "gray",
                }}
              >
                Bill to:
              </div>
              <div
                style={{
                  fontSize: "10px",
                  fontFamily: "Helvetica",
                  fontWeight: 700,
                }}
              >
                {caseDetails.patient.firstName +
                  " " +
                  caseDetails.patient.lastName}
              </div>
            </Stack>
          </Grid>
          <Grid item xs={6}>
            <Grid container>
              <Grid
                xs={6}
                item
                style={{
                  fontSize: "10px",
                  fontFamily: "Helvetica",
                  fontWeight: 600,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "4px",
                  color: "gray",
                }}
              >
                Date:
              </Grid>
              <Grid
                xs={6}
                item
                style={{
                  fontSize: "10px",
                  fontFamily: "Helvetica",
                  fontWeight: 600,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "4px",
                }}
              >
                {normalizeDateTime(Date.now())}
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  fontSize: "10px",
                  fontFamily: "Helvetica",
                  fontWeight: 700,
                  backgroundColor: "#F0F0F0",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "4px",
                }}
              >
                Balance Due:
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  fontSize: "10px",
                  fontFamily: "Helvetica",
                  fontWeight: 700,
                  backgroundColor: "#F0F0F0",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "4px",
                }}
              >
                {"PHP " +
                  (
                    caseDetails.treatmentTypeTotalAmount - totalAmountPaid
                  ).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div
          style={{
            marginTop: "20px",
            marginBottom: "20px",
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
          }}
        >
          <div
            style={{
              flex: "1 0 30%",
              fontSize: "10px",
              fontFamily: "Helvetica",
              fontWeight: 600,
              color: "white",
              backgroundColor: "black",
              padding: "4px",
            }}
          >
            Item
          </div>
          <div
            style={{
              flex: "1 0 10%",
              fontSize: "10px",
              fontFamily: "Helvetica",
              fontWeight: 600,
              color: "white",
              backgroundColor: "black",
              padding: "4px",
            }}
          >
            Quantity
          </div>
          <div
            style={{
              flex: "1 0 20%",
              fontSize: "10px",
              fontFamily: "Helvetica",
              fontWeight: 600,
              color: "white",
              backgroundColor: "black",
              padding: "4px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            Rate
          </div>
          <div
            style={{
              flex: "1 0 20%",
              fontSize: "10px",
              fontFamily: "Helvetica",
              fontWeight: 600,
              color: "white",
              backgroundColor: "black",
              padding: "4px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            Amount
          </div>
          <div
            style={{
              flex: "1 0 30%",
              padding: "4px",
              fontSize: "10px",
              fontFamily: "Helvetica",
              fontWeight: 700,
              color: "black",
              flexWrap: "wrap",
            }}
          >
            {"Alina " + caseDetails.treatmentType.name}
          </div>
          <div
            style={{
              flex: "1 0 10%",
              padding: "4px",
              fontSize: "10px",
              fontFamily: "Helvetica",
              fontWeight: 600,
              color: "black",
            }}
          >
            1
          </div>
          <div
            style={{
              flex: "1 0 20%",
              padding: "4px",
              fontSize: "10px",
              fontFamily: "Helvetica",
              fontWeight: 600,
              color: "black",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {"PHP " +
              caseDetails.treatmentTypeTotalAmount.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
          </div>
          <div
            style={{
              flex: "1 0 20%",
              padding: "4px",
              fontSize: "10px",
              fontFamily: "Helvetica",
              fontWeight: 600,
              color: "black",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {"PHP " +
              caseDetails.treatmentTypeTotalAmount.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
          </div>
          <div
            style={{
              flex: "1 0 30%",
              padding: "4px",
              fontSize: "10px",
              fontFamily: "Helvetica",
              fontWeight: 700,
              color: "black",
            }}
          >
            3D Smile Scan
          </div>
          <div
            style={{
              flex: "1 0 10%",
              padding: "4px",
              fontSize: "10px",
              fontFamily: "Helvetica",
              fontWeight: 600,
              color: "black",
            }}
          >
            1
          </div>
          <div
            style={{
              flex: "1 0 20%",
              padding: "4px",
              fontSize: "10px",
              fontFamily: "Helvetica",
              fontWeight: 600,
              color: "black",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {"PHP " +
              (0).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
          </div>
          <div
            style={{
              flex: "1 0 20%",
              padding: "4px",
              fontSize: "10px",
              fontFamily: "Helvetica",
              fontWeight: 600,
              color: "black",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {"PHP " +
              (0).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
          </div>
        </div>

        <Grid container style={{ justifyContent: "flex-end" }}>
          <Grid item xs={6}>
            <Grid container>
              <Grid
                xs={6}
                item
                style={{
                  fontSize: "10px",
                  fontFamily: "Helvetica",
                  fontWeight: 600,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "4px",
                  color: "gray",
                }}
              >
                Total:
              </Grid>
              <Grid
                xs={6}
                item
                style={{
                  fontSize: "10px",
                  fontFamily: "Helvetica",
                  fontWeight: 600,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "4px",
                }}
              >
                {"PHP " +
                  caseDetails.treatmentTypeTotalAmount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  fontSize: "10px",
                  fontFamily: "Helvetica",
                  fontWeight: 600,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "4px",
                  color: "gray",
                }}
              >
                Amount Paid:
              </Grid>
              <Grid
                item
                xs={6}
                style={{
                  fontSize: "10px",
                  fontFamily: "Helvetica",
                  fontWeight: 600,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  padding: "4px",
                }}
              >
                {"PHP " +
                  totalAmountPaid.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <div
          style={{
            fontSize: "10px",
            fontFamily: "Helvetica",
            fontWeight: 600,
            color: "gray",
          }}
        >
          Notes:
        </div>
        <div
          style={{
            fontSize: "10px",
            fontFamily: "Helvetica",
            color: "black",
          }}
        >
          3D Smile Scan Value - PHP 10,000.00 (Free)
        </div>
        <div
          style={{
            fontSize: "10px",
            fontFamily: "Helvetica",
            color: "black",
          }}
        >
          {caseDetails.treatmentType.name +
            " Treatment Cost - " +
            "PHP " +
            caseDetails.treatmentTypeTotalAmount.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
        </div>
        <br />
        <div
          style={{
            fontSize: "10px",
            fontFamily: "Helvetica",
            fontWeight: 600,
            color: "gray",
          }}
        >
          Bank Details:
        </div>
        <div>RCBC (Rizal Commercial Banking Corporation)</div>
        <div>MCKINLEY DENTAL PROSTHETICS INC.</div>
        <div>Account no. 0000007591135359</div>
        <br />

        <div
          style={{
            fontSize: "10px",
            fontFamily: "Helvetica",
            fontWeight: 600,
            color: "gray",
          }}
        >
          Terms:
        </div>
        <div>
          {"After the " +
            "PHP " +
            downPayment.paymentSchedules[0].amountOrNumberOfSets.toLocaleString(
              "en-US",
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }
            ) +
            " Downpayment"}
        </div>
        {termsOfPaymentAfterDesign.map((t) => {
          return (
            <div>
              {t.paymentSchedules[0].amountOrNumberOfSets +
                " Installments - PHP " +
                (isDownpaymentPaid
                  ? (caseDetails.treatmentTypeTotalAmount - totalAmountPaid) /
                    t.paymentSchedules[0].amountOrNumberOfSets
                  : (caseDetails.treatmentTypeTotalAmount -
                      totalAmountPaid -
                      downPayment.paymentSchedules[0].amountOrNumberOfSets) /
                    t.paymentSchedules[0].amountOrNumberOfSets
                ).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }) +
                "/" +
                (t.paymentSchedules[0].intervalByDays % 31 === 0
                  ? t.paymentSchedules[0].intervalByDays / 31 !== 1
                    ? t.paymentSchedules[0].intervalByDays / 31 + " Months"
                    : "Month"
                  : t.paymentSchedules[0].intervalByDays / 7 !== 1
                  ? t.paymentSchedules[0].intervalByDays / 7 + " Weeks"
                  : "Week")}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default TreatmentQuote;
